import Base from "components/Creation/components/Base";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import useSelection from "hooks/useSelection";
import useAccount from "hooks/useAccount";
import useStripe from "hooks/useStripe";
import useBookings from "hooks/useBookings";
import BookingSummary from "./components/BookingSummary";
import Cost from "./components/BookingSummary/components/Cost";
import MirumBtn from "components/MirumBtn";
import { Animated } from "react-animated-css";
import { FaInfoCircle } from "react-icons/fa";
import { AiOutlineInfoCircle } from "react-icons/ai";
import MirumModal from "components/MirumModal";
import { useCorporateMode } from "context/CorporateModeContext";

const Confirm = () => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showCollectCardModal, setShowCollectCardModal] = useState(false);
  const [isConfirmingBooking, setIsConfirmingBooking] = useState(false);
  const [stripe, setStripe] = useState(null);
  const [additional3Surprises, setAdditional3Surprises] = useState(false);
  const { bookingHasBeenPaid, getCost } = useBookings();
  const stripeHook = useStripe();
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [showTAndCs, setShowTAndCs] = useState(true);

  const getAndSetStripe = async () => {
    setStripe(await stripeHook.getStripe());
    console.log("got stripe", stripe);
  };

  const booking = useSelector((state) => {
    return state.booking;
  });

  const selection = useSelector((state) => {
    return state.booking.selection;
  });

  const { isCorporate } = useCorporateMode();

  const user = useSelector((state) => {
    return state.auth.user;
  });

  useEffect(() => {
    setAdditional3Surprises(selection.additional3Surprises);
  }, [selection]);

  const {
    submitSelection,
    getAndSetSelectionByBookingId,
    redirectIfNotValidUpUntilKey,
    setSelectionForKey,
  } = useSelection({
    key: "additional3Surprises",
    setter: setAdditional3Surprises,
  });

  const { userIsLoggedIn, userHasMandatoryDetails } = useAccount();

  useEffect(() => {
    getAndSetStripe();
  }, []);

  useEffect(() => {
    console.log("useEffect triggered");

    if (booking?.status === "confirmed") {
      setShowTAndCs(false);
    } else {
      redirectIfNotValidUpUntilKey("confirm");
    }

    //Must be logged in to confirm booking, have a booking id and user has clicked confirm

    if (!isConfirmingBooking) {
      console.log("Not pressed confirmed booking yet");
      return;
    }

    if (!userIsLoggedIn(user)) {
      console.log("User not logged in!");
      setShowLoginModal(true);
      return;
    } else if (!userHasMandatoryDetails(user)) {
      console.log("User has not completed mandatory details", user);
      setShowDetailsModal(true);
      return;
    }

    setShowDetailsModal(false);

    if (!booking.user) {
      console.log("no user in booking adding");
      submitSelection();
    }

    if (booking._id) {
      processPayment();
    } else {
      console.log("no booking id yet");
    }

    // if (isConfirmingBooking && userIsLoggedIn(user)) {
    //   if (!booking.user) {
    //     console.log("no user in booking adding");
    //     submitSelection();
    //   } else if (booking._id) {
    //     processPayment();
    //   } else {
    //     console.warn("No booking id yet - waiting for it...");
    //   }
    // }

    if (booking.status === "confirmed") {
      setShowTAndCs(false);
    }
  }, [booking, isConfirmingBooking, user]);

  const SelectionValue = ({ obj }) => {
    let returnValue = null;

    if (!obj) {
      return null;
    }

    if (typeof obj === "string") {
      returnValue = obj;
    } else if (typeof obj === "object") {
      returnValue = <Selection obj={obj} />;
    } else if (typeof obj === "array") {
      returnValue = (
        <div>
          {obj.map((item) => {
            return (
              <span>
                <Selection obj={item} />,
              </span>
            );
          })}
        </div>
      );
    } else if (obj === true || obj === false) {
      returnValue = obj === true ? "Yes" : "No";
    } else {
      returnValue = "No";
    }

    return returnValue;
  };

  const Selection = ({ obj }) => {
    return (
      <ul className="ml-4">
        {Object.keys(obj).map((key) => {
          console.log("key", key);
          return (
            <li key={key}>
              {key}: <SelectionValue obj={obj[key]} />
            </li>
          );
        })}
      </ul>
    );
  };

  const processPayment = async () => {
    console.log("process payment", selection);

    console.log("Stripe user", user.stripe);

    console.log("Collect payment for", booking._id);

    //Show the user a note that still need to collect card details for No show if cost is 0.
    let cost = await getCost(booking._id);
    if (
      (!user.stripe?.checkoutSessionId || !user.stripe?.setupIntentId) &&
      cost.total === 0
    ) {
      setShowCollectCardModal(true);
    } else {
      await collectPayment();
    }
  };

  const collectPayment = async () => {
    await stripeHook.collectPayment(booking._id, user);
  };

  const processBooking = async () => {
    console.log("processBooking()", user);

    if (!acceptedTerms) {
      return alert(
        "please ensure you've read and accepted the terms and conditions"
      );
    }

    setIsConfirmingBooking(true);
    // if (!userIsLoggedIn(user)) {
    //   console.log("User not logged in - show modal");
    //   setShowLoginModal(true);
    // } else if (!booking._id) {
    //   console.log("no booking id submitting...");
    //   await submitSelection();
    // }
  };

  return (
    <Base
      footerRelative={true}
      footerHideNextBtn={booking.status === "confirmed"}
      footerHideBackBtn={booking.status === "confirmed"}
      footerUseConfirmBtn={true}
      footerOnClickedNext={async () => {
        await processBooking();
      }}
      // title={`Confirm ${booking._id} ${
      //   booking.status === "confirmed" ? "Is Confirmed" : "Not confirmed"
      // }`}
      title={
        booking.status !== "confirmed"
          ? "Confirm your surprise"
          : "Surprise details"
      }
      shouldShowLoginModal={showLoginModal}
      loginModalOnDidDismiss={() => {
        setShowLoginModal(false);
        setIsConfirmingBooking(false);
      }}
      onLoggedIn={async () => {
        // if (isConfirmingBooking) {
        //   await submitSelection(); //To ensure user is attached to booking
        //   await processBooking();
        // }
        // setShowLoginModal(false);
      }}
      showDetailsModal={showDetailsModal}
      detailsModalOnDidDismiss={() => {
        setShowDetailsModal(false);
        setIsConfirmingBooking(false);
      }}
      className="pb-8"
      infoBody={
        <span>
          note: we will also hold an amount of £25 per person, which will only
          be charged in the case of a cancellation within 48 hours prior to the
          surprise, or in the event of a no-show. please see the t&cs for more
          info
        </span>
      }
    >
      {/* SUMMARY */}
      <BookingSummary booking={booking} selection={selection} />

      {/* INCENTIVE */}
      {!isCorporate &&
      !additional3Surprises &&
      !bookingHasBeenPaid(booking) && (
        <div className="container">
          <div className="w-full md:w-8/12 mx-auto p-4">
            <div
              className="flex flex-col md:flex-row w-full items-center bg-[#F9F9FC] py-4 md:px-8 rounded-3xl "
              style={{ boxShadow: "0px 0px 38px rgba(0,0,0,0.1)" }}
            >
              <div className="grow flex-col md:flex-row md:flex items-center text-center md:text-left">
                <div>
                  <Animated animationIn="tada">
                    <img
                      src="/images/confirm/icons/party.png"
                      className="w-[50px] mx-auto"
                    />
                  </Animated>
                </div>
                <p className="text-black font-black md:mx-2 ">
                  book a bundle of 4 surprises right now for £29.99!&nbsp;
                  <a
                    href="https://www.themirum.co.uk/terms-and-conditions"
                    className="mirum-color-blue font-black underline cursor-pointer"
                    target="_blank"
                  >
                    terms &amp; conditions
                  </a>
                  &nbsp;apply
                </p>
              </div>
              <div className="p-4 md:p-0">
                <MirumBtn
                  bgColor="blue"
                  className="px-8 w-full md:w-auto"
                  onClick={() => {
                    setSelectionForKey(true);
                  }}
                >
                  Add
                </MirumBtn>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* COST */}
      <div className="container">
        <div className="md:w-6/12 mx-auto p-4">
          {isCorporate && !bookingHasBeenPaid(booking) && (
            <div
              className="mb-6 p-4 md:p-5 rounded-2xl border border-[var(--orange)]/35 bg-white lowercase shadow-sm"
              style={{ boxShadow: "0px 0px 24px rgba(0,0,0,0.06)" }}
            >
              <div className="flex gap-3 items-start">
                <AiOutlineInfoCircle
                  className="shrink-0 mt-0.5"
                  style={{
                    fontSize: "22px",
                    color: "var(--orange)",
                  }}
                />
                <p className="text-black text-sm md:text-base leading-relaxed m-0">
                  <strong className="font-bold">quote request:</strong> the
                  payment below is for a quote. we will get back to you at the
                  email address you have provided within{" "}
                  <strong className="font-bold">3 working days</strong>.
                </p>
              </div>
            </div>
          )}
          <Cost bookingId={booking._id} className="w-6/12 ml-auto" />
        </div>
      </div>

      {/* T&CS */}
      {showTAndCs && (
        <div className=" container md:mb-8 md:text-right">
          <div className="md:w-7/12 mx-auto p-4">
            <div className="mb-2">
              <AiOutlineInfoCircle
                style={{
                  fontSize: "24px",
                  display: "inline",
                  color: "var(--orange)",
                }}
              />
              <p className=" inline ml-2 lowercase font-bold text-black text-sm md:pb-4">
                note: we will also hold an amount of £25 per person, which will
                only be charged in the case of a cancellation within 48 hours
                prior to the surprise, or in the event of a no-show. please see
                the&nbsp;
                <a
                  className=""
                  href="https://www.themirum.co.uk/terms-and-conditions"
                  target="_blank"
                >
                  t&cs
                </a>
                &nbsp;for more info
              </p>
            </div>
            <div className="flex md:items-center w-full md:justify-end md:pb-8">
              <div>
                <input
                  type="checkbox"
                  className="mr-2"
                  id="terms"
                  value={acceptedTerms}
                  onChange={(e) => {
                    // console.log("checked");
                    // alert("changed: " + e.target.checked);
                    setAcceptedTerms(!acceptedTerms);
                  }}
                />
              </div>
              <label for="terms" className="cursor-pointer">
                <p className="lowercase font-bold text-black text-sm">
                  I have read and accepted mirum's&nbsp;
                  <a
                    className="underline mirum-color-blue"
                    href="https://www.themirum.co.uk/terms-and-conditions"
                    target="_blank"
                  >
                    Terms &amp; Conditions
                  </a>
                </p>
              </label>
            </div>
          </div>
        </div>
      )}

      {/* DONE */}
      {!showTAndCs && (
        <div className="w-full text-right mb-8 mr-8 px-4">
          <MirumBtn className="px-10 w-full  md:w-auto" href={`/`}>
            Done
          </MirumBtn>
        </div>
      )}

      {/* NOTE */}
      <MirumModal
        show={showCollectCardModal}
        onDidDismiss={() => {
          setShowCollectCardModal(false);
          setIsConfirmingBooking(false);
        }}
        onPositiveBtnClick={collectPayment}
      >
        <div class="p-4">
          <h1>free booking!</h1>
          <p class="mt-2">
            congratulations! there's no fee for your booking. however, we still
            need to collect your card details inline with our terms and
            conditions in case of a no-show. press ok to continue.
          </p>
        </div>
      </MirumModal>
    </Base>
  );
};

export default Confirm;
